module.exports = __webpack_public_path__ + "img/board_01.56e3b667.svg";